import loadable from '@loadable/component';

export const EditOrgLinksLoadable = loadable(
  () =>
    import(
      /* webpackChunkName: "EditOrgLinks" */
      './EditOrgLinks.dynamic'
    ),
);
